// SpinalCordInjuryCare.js
import React from 'react';
import ServiceHero from '../components/ServiceHero';
import SpinalCordIndependenceSection from '../components/SpinalCordIndependenceSection';
import ProudlyCaringSeniorsSection from '../components/ProudlyCaringSeniorsSection';
import ComprehensiveInHomeCareSection from '../components/ComprehensiveInHomeCareSection';
import ThreeStepsSection from '../components/ThreeStepsSection';
import AllServicesShowcase from '../components/AllServicesShowcase';

const SpinalCordInjuryCare = () => {
  const breadcrumbs = [
    { label: 'Home', link: '/' },
    { label: 'Home Care Services', link: '/services' },
    { label: 'Spinal Cord Injury Care', link: null }
  ];

  return (
    <div className="min-h-screen bg-white">
      <ServiceHero
        breadcrumbs={breadcrumbs}
        title="Empowering Recovery with Specialized Spinal Cord Injury Care"
        description="Our caregivers deliver attentive support to help individuals with spinal cord injuries regain strength, independence, and confidence in daily life."
      />
      <SpinalCordIndependenceSection />
      <ProudlyCaringSeniorsSection />
      <ComprehensiveInHomeCareSection />
      <ThreeStepsSection />
      <AllServicesShowcase />
    </div>
  );
};

export default SpinalCordInjuryCare;
